/**
 *
 * Asynchronously loads the component for ThirdPartyResultsPage
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
